import { render } from "./ChangeLogoModal.vue?vue&type=template&id=bcf601d0&scoped=true"
import script from "./ChangeLogoModal.vue?vue&type=script&lang=js"
export * from "./ChangeLogoModal.vue?vue&type=script&lang=js"

import "./ChangeLogoModal.vue?vue&type=style&index=0&id=bcf601d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcf601d0"]])

export default __exports__